<template>
  <el-dialog
    :visible="validAccountForm"
    class="emptyAct"
    @close="closeValidAccount"
  >
    <p class="top">
      <span class="current account">{{ $t("currentAccount") }}:</span>
      <span class="account">{{ nickname }}</span>
    </p>
    <p class="line"></p>
    <p class="validMsg">
      {{ $t("validMsg") }}
    </p>
    <div class="gameInfo">
      <img class="gameImg float-l" :src="lastRole.iconUrl" alt="" />
      <p class="lastRole float-l">
        <span>{{ lastRole.gameName + "  " + lastRole.serverName }}</span>
        <span>
          {{ lastRole.roleName }}
        </span>
        <el-button
          size="small"
          class="shopping"
          @click="pushRouter('Recharge')"
          >{{ $t("goRecharge") }}</el-button
        >
      </p>
    </div>
    <p class="validMsg" style="font-size: 16px">
      {{ $t("goto") }}
      <span class="blue" @click="pushRouter('MyGame')">{{
        $t("persion")
      }}</span>
      {{ $t("haveRoles") }}
    </p>
    <div class="countDown">{{ count }}s</div>
  </el-dialog>
</template>
<script>
import { getHotGameList } from "@/api/gameList";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      count: 5,
      timeId: null,
    };
  },
  computed: {
    ...mapGetters(["nickname", "validAccountForm", "lastRole"]),
  },
  mounted() {
    this.timeId = setInterval(() => {
      this.count--;
      if (this.count == 0) {
        this.$store.dispatch("validAccountForm", false);
        window.clearInterval(this.timeId);
      }
    }, 1000);
  },

  methods: {
    closeValidAccount() {
      window.clearInterval(this.timeId);
      this.$store.dispatch("validAccountForm", false);
    },
    pushRouter(page) {
      window.clearInterval(this.timeId);
      this.$store.dispatch("validAccountForm", false);
      this.$router.push({
        name: page,
        params: {
          gameId: this.lastRole.gameId,
          serverId: this.lastRole.serverId,
          roleId: this.lastRole.roleId,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.emptyAct {
  .top {
    height: 60px;
  }
  .current {
    margin: 10px 10px 0 40px;
  }
  .line {
    height: 2px;
    background-image: linear-gradient(to right, #2c2c2c, #de9a2d, #2c2c2c);
  }
  .gameInfo {
    height: 160px;
    margin-top: 20px;
    .gameImg {
      width: 160px;
      margin-left: 40px;
    }
    .lastRole {
      width: 300px;
      text-align: center;
      color: #ffffff;
      font-size: 18px;
      span {
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 40px;
        display: block;
      }
      .shopping {
        border: none;
        color: #f4cc65;
        background-image: linear-gradient(to right, #252525, #141414, #252525);
        font: normal bold 16px/60px arial;
        padding: 4px 24px;
      }
    }
  }
  .account {
    color: #9c9c9c;
    font: normal bold 16px/60px arial;
  }
  .loginBtn {
    margin: 10px 60px 0 0;
    border-radius: 30px;
  }
  .validMsg {
    text-align: center;
    color: #9c9c9c;
    font: normal bold 16px/80px arial;
    .blue {
      cursor: pointer;
      color: #ffffff;
    }
  }
  .countDown {
    text-align: center;
  }
  .el-dialog {
    background: #2c2c2c;
    height: 480px;
    width: 540px;
    .el-dialog__body {
      padding-top: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/validAccount.vue